<template>
    <div v-for="(item) in options" :key="item.key" class="flex flex-col">
        <SwitchGroup as="div" class="flex items-center">
            <Switch @click="handleUpdate" v-model="item.selected"
                    :class="[item.selected ? 'bg-green-600' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500']">
                <span class="sr-only">{{ item.name }}</span>
                <span aria-hidden="true"
                      :class="[item.selected ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']"/>
            </Switch>
            <SwitchLabel as="span" class="ml-3">
                <span class="text-sm font-medium text-gray-900">{{ item.name }}</span>
                <span class="text-sm text-gray-500"></span>
            </SwitchLabel>
        </SwitchGroup>
    </div>
</template>

<script setup>
import {onMounted, ref, watch} from 'vue'
import {Switch, SwitchGroup, SwitchLabel} from '@headlessui/vue'

const props = defineProps({options: Array})
const emit = defineEmits(['update'])

//const items = ref([])

const handleUpdate = () => {
    emit('update', props.options)
}

onMounted(() => {
    //items.value = props.options?.map(element => Object.assign({selected: false}, element))
})
</script>
